export default __webpack_public_path__ + "28a3ba5a304a8afc1b3ac0d632652649.svg";